// src/components/TabPanel.js
import React from 'react';

const TabPanel = ({ children, value, index, ...other }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <div style={{ padding: '20px 0' }}>{children}</div>}
    </div>
  );
};

export default TabPanel;